(function () {
  if (window.CCVinutCartLoopReplacement) return;
  window.CCVinutCartLoopReplacement = true;

  var SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
  var loopLabelResizeObserver = null;
  var loopLabelFitFrame = null;

  function headers() {
    return {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };
  }

  function themeString(key, fallback) {
    return window.theme && window.theme.strings && window.theme.strings[key]
      ? window.theme.strings[key]
      : fallback;
  }

  function routeUrl(key, fallback) {
    return window.theme && window.theme.routes && window.theme.routes[key]
      ? window.theme.routes[key]
      : fallback;
  }

  function jsonRouteUrl(key, fallback) {
    var url = routeUrl(key, fallback);
    if (url.slice(-3) !== '.js') url += '.js';
    return url;
  }

  function setCartError(message) {
    var errors = document.getElementById('cart-errors');
    if (errors) errors.textContent = message || '';
  }

  function lockCart() {
    document.dispatchEvent(new CustomEvent('shapes:cart:lock'));
  }

  function unlockCart() {
    document.dispatchEvent(new CustomEvent('shapes:cart:unlock'));
  }

  function setControlBusy(target, busy, mode) {
    if (!target) return;

    var label = target.querySelector('[data-cc-loop-button-label]');

    if (busy) {
      target.disabled = true;
      target.setAttribute('aria-busy', 'true');
      if (label) {
        label.setAttribute('data-original-label', label.textContent);
        label.textContent = mode === 'downgrade' ? 'Downgrading...' : 'Upgrading...';
      }
    } else {
      target.disabled = false;
      target.removeAttribute('aria-busy');
      if (label && label.getAttribute('data-original-label')) {
        label.textContent = label.getAttribute('data-original-label');
        label.removeAttribute('data-original-label');
      }
      scheduleFitLoopButtonLabels();
    }
  }

  function dispatchCartChange(data, detail) {
    document.body.dispatchEvent(
      new CustomEvent('shapes:cart:cartqtychange', {
        bubbles: true,
        detail: {
          response: data,
          key: detail.key,
          quantity: detail.quantity,
          previousQuantity: detail.quantity,
          variantId: detail.variantId || null,
          originalTarget: detail.originalTarget || null
        }
      })
    );
  }

  function dispatchCartAdd(data, originalTarget) {
    document.body.dispatchEvent(
      new CustomEvent('shapes:cart:afteradditem', {
        bubbles: true,
        detail: {
          response: data,
          sourceId: null,
          originalTarget: originalTarget || null
        }
      })
    );
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  }

  async function postCartChange(payload) {
    var response = await fetch(jsonRouteUrl('cart_change_url', '/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers(),
      body: JSON.stringify(payload)
    });

    var data = await response.json();

    if (!response.ok || data.status) {
      var error = new Error(data.description || data.message || themeString('cartError', 'Cart error'));
      error.responseData = data;
      throw error;
    }

    return data;
  }

  function cartAddJsonUrl() {
    return jsonRouteUrl('cart_add_url', '/cart/add.js');
  }

  async function postCartAddJson(payload) {
    var response = await fetch(cartAddJsonUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: headers(),
      body: JSON.stringify(payload)
    });

    var data = await response.json();

    if (!response.ok || data.status) {
      var error = new Error(data.description || data.message || themeString('cartAddError', 'Cart add error'));
      error.responseData = data;
      throw error;
    }

    return data;
  }

  async function replaceLineWithSellingPlan(control, sellingPlan, quantity) {
    var key = control.getAttribute('data-line-key');
    var line = Number(control.getAttribute('data-line') || 0);
    var variantId = Number(control.getAttribute('data-variant-id') || 0);

    if (!variantId || !sellingPlan) {
      throw new Error(themeString('cartError', 'Cart error'));
    }

    try {
      await postCartAddJson({
        id: variantId,
        quantity: quantity,
        selling_plan: Number(sellingPlan),
        sections: SECTIONS,
        sections_url: window.location.pathname
      });
    } catch (singleAddError) {
      await postCartAddJson({
        items: [
          {
            id: variantId,
            quantity: quantity,
            selling_plan: Number(sellingPlan)
          }
        ],
        sections: SECTIONS,
        sections_url: window.location.pathname
      });
    }

    var removeBasePayload = {
      quantity: 0,
      sections: SECTIONS,
      sections_url: window.location.pathname
    };
    var removePayloads = [];

    if (key) {
      removePayloads.push(Object.assign({}, removeBasePayload, { id: key }));
    }

    if (line) {
      removePayloads.push(Object.assign({}, removeBasePayload, { line: line }));
    }

    if (!removePayloads.length) {
      removePayloads.push(Object.assign({}, removeBasePayload, { id: variantId }));
    }

    var lastError;

    for (var i = 0; i < removePayloads.length; i++) {
      try {
        return await postCartChange(removePayloads[i]);
      } catch (error) {
        lastError = error;
      }
    }

    throw lastError || new Error(themeString('cartError', 'Cart error'));
  }

  function updateUpsellScrollbar(scroller) {
    if (!scroller) return;

    var scrollbar = scroller.parentNode && scroller.parentNode.querySelector('[data-cc-cart-upsell-scrollbar]');
    var thumb = scrollbar && scrollbar.querySelector('.cc-cart-upsells__scrollbar-thumb');
    if (!scrollbar || !thumb) return;

    var scrollWidth = scroller.scrollWidth;
    var clientWidth = scroller.clientWidth;
    var maxScroll = scrollWidth - clientWidth;

    if (maxScroll <= 1) {
      scrollbar.style.display = 'none';
      return;
    }

    scrollbar.style.display = 'block';

    var thumbWidth = Math.max(18, Math.min(100, clientWidth / scrollWidth * 100));
    var maxLeft = 100 - thumbWidth;
    var left = maxScroll > 0 ? scroller.scrollLeft / maxScroll * maxLeft : 0;

    thumb.style.width = thumbWidth + '%';
    thumb.style.left = left + '%';
    thumb.style.transform = 'translateY(-50%)';
  }

  function getUpsellScrollbarParts(scroller) {
    if (!scroller || !scroller.parentNode) return null;

    var scrollbar = scroller.parentNode.querySelector('[data-cc-cart-upsell-scrollbar]');
    var thumb = scrollbar && scrollbar.querySelector('.cc-cart-upsells__scrollbar-thumb');
    if (!scrollbar || !thumb) return null;

    return {
      scrollbar: scrollbar,
      thumb: thumb
    };
  }

  function scrollUpsellsFromPointer(scroller, scrollbar, clientX, dragOffset) {
    var scrollWidth = scroller.scrollWidth;
    var clientWidth = scroller.clientWidth;
    var maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 1) return;

    var trackRect = scrollbar.getBoundingClientRect();
    var thumb = scrollbar.querySelector('.cc-cart-upsells__scrollbar-thumb');
    var thumbRect = thumb.getBoundingClientRect();
    var maxThumbLeft = Math.max(1, trackRect.width - thumbRect.width);
    var nextThumbLeft = clientX - trackRect.left - dragOffset;

    nextThumbLeft = Math.max(0, Math.min(maxThumbLeft, nextThumbLeft));
    scroller.scrollLeft = nextThumbLeft / maxThumbLeft * maxScroll;
    updateUpsellScrollbar(scroller);
  }

  function bindUpsellScrollbarDrag(scroller) {
    var parts = getUpsellScrollbarParts(scroller);
    if (!parts || parts.scrollbar.getAttribute('data-cc-scrollbar-drag-bound') === 'true') return;

    var scrollbar = parts.scrollbar;
    var thumb = parts.thumb;
    var activePointerId = null;
    var dragOffset = 0;

    scrollbar.setAttribute('data-cc-scrollbar-drag-bound', 'true');

    scrollbar.addEventListener('pointerdown', function (event) {
      var scrollWidth = scroller.scrollWidth;
      var clientWidth = scroller.clientWidth;
      if (scrollWidth - clientWidth <= 1) return;

      event.preventDefault();
      activePointerId = event.pointerId;

      var thumbRect = thumb.getBoundingClientRect();
      if (event.target === thumb) {
        dragOffset = event.clientX - thumbRect.left;
      } else {
        dragOffset = thumbRect.width / 2;
      }

      scrollbar.classList.add('is-dragging');
      if (scrollbar.setPointerCapture) scrollbar.setPointerCapture(activePointerId);
      scrollUpsellsFromPointer(scroller, scrollbar, event.clientX, dragOffset);
    });

    scrollbar.addEventListener('pointermove', function (event) {
      if (activePointerId === null || event.pointerId !== activePointerId) return;

      event.preventDefault();
      scrollUpsellsFromPointer(scroller, scrollbar, event.clientX, dragOffset);
    });

    function stopDragging(event) {
      if (activePointerId === null || event.pointerId !== activePointerId) return;

      if (scrollbar.releasePointerCapture) {
        try {
          scrollbar.releasePointerCapture(activePointerId);
        } catch (error) {}
      }

      activePointerId = null;
      scrollbar.classList.remove('is-dragging');
    }

    scrollbar.addEventListener('pointerup', stopDragging);
    scrollbar.addEventListener('pointercancel', stopDragging);
  }

  function bindUpsellScrollbars() {
    document.querySelectorAll('[data-cc-cart-upsells]').forEach(function (scroller) {
      updateUpsellScrollbar(scroller);
      bindUpsellScrollbarDrag(scroller);

      if (scroller.getAttribute('data-cc-scrollbar-bound') === 'true') return;

      scroller.setAttribute('data-cc-scrollbar-bound', 'true');
      scroller.addEventListener('scroll', function () {
        updateUpsellScrollbar(scroller);
      }, { passive: true });
    });
  }

  function setImportantStyle(element, property, value) {
    if (!element || !element.style || !element.style.setProperty) return;

    element.style.setProperty(property, value, 'important');
  }

  function fitLoopButtonLabels() {
    document.querySelectorAll('[data-cart-drawer] [data-cc-loop-button-label]').forEach(function (label) {
      var button = label.closest('.cc-cart-loop__button');
      if (!button || !label.textContent.trim()) return;

      var maxSize = 12;
      var minSize = 8;
      var size = maxSize;

      setImportantStyle(button, 'font-size', maxSize + 'px');
      setImportantStyle(label, 'font-size', maxSize + 'px');

      if (label.clientWidth <= 0) return;

      while (size > minSize && label.scrollWidth > label.clientWidth + 1) {
        size = Math.max(minSize, size - 0.25);
        setImportantStyle(button, 'font-size', size + 'px');
        setImportantStyle(label, 'font-size', size + 'px');
      }
    });
  }

  function scheduleFitLoopButtonLabels() {
    if (!window.requestAnimationFrame) {
      fitLoopButtonLabels();
      return;
    }

    if (loopLabelFitFrame && window.cancelAnimationFrame) {
      window.cancelAnimationFrame(loopLabelFitFrame);
    }

    loopLabelFitFrame = window.requestAnimationFrame(function () {
      loopLabelFitFrame = null;
      fitLoopButtonLabels();
    });
  }

  function observeLoopButtonLabels() {
    if (!('ResizeObserver' in window)) return;

    if (!loopLabelResizeObserver) {
      loopLabelResizeObserver = new ResizeObserver(scheduleFitLoopButtonLabels);
    }

    document.querySelectorAll('[data-cart-drawer] [data-cc-loop-button-label]').forEach(function (label) {
      var button = label.closest('.cc-cart-loop__button');
      if (!button || button.getAttribute('data-cc-loop-label-observed') === 'true') return;

      button.setAttribute('data-cc-loop-label-observed', 'true');
      loopLabelResizeObserver.observe(button);
    });
  }

  function refreshDrawerEnhancements() {
    bindUpsellScrollbars();
    observeLoopButtonLabels();
    scheduleFitLoopButtonLabels();
  }

  async function upgradeLineToSellingPlan(control, sellingPlan, originalTarget) {
    if (!control || !sellingPlan) return;

    var key = control.getAttribute('data-line-key');
    var variantId = Number(control.getAttribute('data-variant-id') || 0);
    var quantity = Number(control.getAttribute('data-quantity') || 1);
    if (!variantId) return;

    lockCart();
    setCartError('');
    setControlBusy(originalTarget, true, 'upgrade');

    try {
      var data = await replaceLineWithSellingPlan(control, sellingPlan, quantity);

      dispatchCartChange(data, {
        key: key,
        quantity: quantity,
        variantId: variantId,
        originalTarget: originalTarget
      });
      refreshCart();
    } catch (error) {
      console.error(error);
      setCartError(error.message || themeString('cartError', 'Cart error'));
      document.dispatchEvent(
        new CustomEvent('theme:cart:error:other', {
          detail: {
            message: error.message || themeString('cartError', 'Cart error'),
            error: error
          }
        })
      );
    } finally {
      setControlBusy(originalTarget, false);
      unlockCart();
    }
  }

  async function changeLineSellingPlan(control, sellingPlan, originalTarget) {
    if (!control) return;

    var key = control.getAttribute('data-line-key');
    var line = Number(control.getAttribute('data-line') || 0);
    var variantId = Number(control.getAttribute('data-variant-id') || 0);
    var quantity = Number(control.getAttribute('data-quantity') || 1);
    if (!line && !key && !variantId) return;

    lockCart();
    setCartError('');

    setControlBusy(originalTarget, true, sellingPlan ? 'upgrade' : 'downgrade');

    try {
      var payload = {
        quantity: quantity,
        sections: SECTIONS,
        sections_url: window.location.pathname
      };

      if (line) {
        payload.line = line;
      } else if (key) {
        payload.id = key;
      } else {
        payload.id = variantId;
      }

      payload.selling_plan = sellingPlan ? Number(sellingPlan) : null;

      var data;
      try {
        data = await postCartChange(payload);
      } catch (firstError) {
        try {
          if (!key || payload.id === key) throw firstError;

          delete payload.line;
          payload.id = key;
          data = await postCartChange(payload);
        } catch (secondError) {
          if (!sellingPlan || !variantId) throw secondError;
          data = await replaceLineWithSellingPlan(control, sellingPlan, quantity);
        }
      }

      dispatchCartChange(data, {
        key: key,
        quantity: quantity,
        originalTarget: originalTarget
      });
      refreshCart();
    } catch (error) {
      console.error(error);
      if (originalTarget && originalTarget.matches('[data-cc-loop-selling-plan]')) {
        originalTarget.value = control.getAttribute('data-current-selling-plan') || '';
      }
      setCartError(error.message || themeString('cartError', 'Cart error'));
      document.dispatchEvent(
        new CustomEvent('theme:cart:error:other', {
          detail: {
            message: error.message || themeString('cartError', 'Cart error'),
            error: error
          }
        })
      );
    } finally {
      setControlBusy(originalTarget, false);
      unlockCart();
    }
  }

  function setButtonBusy(button, busy, busyText) {
    if (!button) return;

    if (busy) {
      button.setAttribute('data-original-label', button.textContent);
      button.textContent = busyText || 'Adding...';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    } else {
      if (button.getAttribute('data-original-label')) {
        button.textContent = button.getAttribute('data-original-label');
        button.removeAttribute('data-original-label');
      }
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  async function addUpsell(form, button) {
    var formData = form ? new FormData(form) : new FormData();
    var variantId = formData.get('id') || (button && button.getAttribute('data-cc-cart-add-variant'));
    var quantity = Number(formData.get('quantity') || 1);

    if (!variantId) {
      setCartError(themeString('cartAddError', 'Cart add error'));
      return;
    }

    lockCart();
    setCartError('');

    setButtonBusy(button, true, 'Adding...');

    try {
      var data = await postCartAddJson({
        id: Number(variantId),
        quantity: quantity,
        sections: SECTIONS,
        sections_url: window.location.pathname
      });

      if (data.sections && data.sections['cart-items'] && data.sections['cart-footer']) {
        dispatchCartAdd(data, button);
        window.requestAnimationFrame(refreshDrawerEnhancements);
      } else {
        refreshCart();
      }
    } catch (error) {
      console.error(error);
      setCartError(error.message || themeString('cartAddError', 'Cart add error'));
      document.dispatchEvent(
        new CustomEvent('theme:cart:error:other', {
          detail: {
            message: error.message || themeString('cartAddError', 'Cart add error'),
            error: error
          }
        })
      );
    } finally {
      setButtonBusy(button, false);
      unlockCart();
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var changeButton = event.target.closest('[data-cc-loop-cart-change]');
    if (changeButton) {
      event.preventDefault();
      var control = changeButton.closest('[data-cc-loop-control]');
      upgradeLineToSellingPlan(control, changeButton.getAttribute('data-selling-plan'), changeButton);
      return;
    }

    var addButton = event.target.closest('[data-cc-cart-add-variant]');
    if (addButton) {
      event.preventDefault();
      addUpsell(addButton.closest('[data-cc-cart-upsell-form]'), addButton);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cc-cart-upsell-form]');
    if (!form) return;

    event.preventDefault();
    addUpsell(form, form.querySelector('[data-cc-cart-add-variant]'));
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-cc-loop-selling-plan]');
    if (!select) return;

    var control = select.closest('[data-cc-loop-control]');
    changeLineSellingPlan(control, select.value, select);
  });

  document.addEventListener('DOMContentLoaded', refreshDrawerEnhancements);
  window.addEventListener('load', refreshDrawerEnhancements);
  window.addEventListener('resize', refreshDrawerEnhancements);
  window.addEventListener('shapes:cart:update', function () {
    window.requestAnimationFrame(refreshDrawerEnhancements);
  });
  window.addEventListener('shapes:cart:cartqtychange', function () {
    window.requestAnimationFrame(refreshDrawerEnhancements);
  });
  window.addEventListener('shapes:cart:afteradditem', function () {
    window.requestAnimationFrame(refreshDrawerEnhancements);
  });
})();
